import { render, staticRenderFns } from "./FormPageFull.vue?vue&type=template&id=4628e773"
import script from "./FormPageFull.vue?vue&type=script&lang=js"
export * from "./FormPageFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports